// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--cgSDw";
export var footerLink = "styles-module--footer-link--fyjpj";
export var footerContainer = "styles-module--footer-container--29nqw";
export var footerImg = "styles-module--footer-img--acNBd";
export var stickyContainer = "styles-module--sticky-container--XCp5U";